import {FC} from 'react'

type ArrowRightSmIconProps = {
  width?: number
  height?: number
  strokeColor?: string
  strokeWidth?: number
  fillColor?: string
  classes?: string
  onClick?: () => void
  ariaLabel?: string
}

// Used by DownloadButton; intended as a design icon within the design system.
const ArrowRightSmIcon: FC<ArrowRightSmIconProps> = ({
  width = 24,
  height = 24,
  strokeColor = 'text-white',
  strokeWidth = 1.2,
  fillColor = '#00000000',
  classes = '',
  onClick,
  ariaLabel,
}) => {
  const isDecorative = !ariaLabel

  return (
    <svg
      data-cy="sm-arrow-icon"
      onClick={onClick}
      width={width}
      height={height}
      fill={fillColor}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={`stroke-current ${strokeColor} ${classes}`}
      aria-label={isDecorative ? undefined : ariaLabel}
      aria-hidden={isDecorative}
      focusable="false"
    >
      <path
        d="M13.75 6.75L19.25 12L13.75 17.25"
        className="stroke-current"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 12H4.75"
        className="stroke-current"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export {ArrowRightSmIcon}
